import { __awaiter, __generator } from 'tslib';
import { getMediaShareTokens } from '@keepeek/api-client';
import Axios from 'axios';
import { selectorFamily, selector } from 'recoil';
import { shareTokensRequestIdState, shareTokenPageNumberState, shareTokenPageSizeState, shareTokenCurrentTemplateIdState } from './atoms.js';
import { getAllShareTemplates, getAllShareTemplateDomains } from './utils.js';

var shareTokensSelector = selectorFamily({
    key: "ShareTokensSelector",
    get: function (elementId) {
        return function (_a) {
            var get = _a.get;
            return __awaiter(this, void 0, void 0, function () {
                var shareTokenResult;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            get(shareTokensRequestIdState(elementId));
                            return [4 /*yield*/, getMediaShareTokens(Axios, {
                                    mediaId: elementId,
                                    page: get(shareTokenPageNumberState(elementId)),
                                    size: get(shareTokenPageSizeState(elementId)),
                                    sort: "creationDate asc"
                                })];
                        case 1:
                            shareTokenResult = _b.sent();
                            return [2 /*return*/, shareTokenResult.data];
                    }
                });
            });
        };
    },
    cachePolicy_UNSTABLE: {
        eviction: "most-recent"
    }
});
var shareTokenTemplatesSelector = selector({
    key: "ShareTokenTemplatesSelector",
    get: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getAllShareTemplates(Axios)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); }
});
var shareTokenTemplateDomainsSelector = selector({
    key: "ShareTokenTemplateDomainsSelector",
    get: function (_a) {
        var get = _a.get;
        return __awaiter(void 0, void 0, void 0, function () {
            var currentTemplateId;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        currentTemplateId = get(shareTokenCurrentTemplateIdState);
                        if (currentTemplateId === 0) {
                            return [2 /*return*/, []];
                        }
                        return [4 /*yield*/, getAllShareTemplateDomains(Axios, currentTemplateId)];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    }
});

export { shareTokenTemplateDomainsSelector, shareTokenTemplatesSelector, shareTokensSelector };
//# sourceMappingURL=selectors.js.map
